__turbopack_context__.v({
  "actions": "CompanyContextBanner-module-scss-module__zDiKgq__actions",
  "banner": "CompanyContextBanner-module-scss-module__zDiKgq__banner",
  "bannerOpen": "CompanyContextBanner-module-scss-module__zDiKgq__bannerOpen",
  "button": "CompanyContextBanner-module-scss-module__zDiKgq__button",
  "solid": "CompanyContextBanner-module-scss-module__zDiKgq__solid",
  "switcher": "CompanyContextBanner-module-scss-module__zDiKgq__switcher",
  "text": "CompanyContextBanner-module-scss-module__zDiKgq__text",
});
